import { jsx as _jsx } from "react/jsx-runtime";
import developPng from '@/shared/assets/png/develop.png';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    home: {
        'height': 'calc(100vh - 170px)',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignitems: 'center',
        '& img': {
            margin: 'auto',
        },
    },
});
export const ErrorPage = () => {
    const styles = useStyles();
    return (_jsx("div", { className: styles.home, children: _jsx("img", { className: 'img', src: developPng, alt: "" }) }));
};
